
/**
 * Capacitor plugin for native Firebase Analytics
 *   https://www.npmjs.com/package/@capacitor-community/firebase-analytics
 * This implementation is implicitly inherited from the /node_modules/vue-gtm/src/index.js.
 * Remember, methods to this class should follow vue-gtm library.
 */
import { CapacitorPluginsBase } from "./capacitorPluginsBase";
class FirebaseAnalyticsPlugin extends CapacitorPluginsBase {
  trackView (screenName, path) {
    this.plugins.FirebaseAnalytics.setScreenName({
      screenName,
      nameOverride: path
    });
  }

  setUser (userId) {
    this.plugins.FirebaseAnalytics.setUserId({ userId });
  }

  trackEvent ({
    event = null,
    category = null,
    action = null,
    label = null,
    value = null,
    noninteraction = false,
    ...rest
  } = {}) {
    this.plugins.FirebaseAnalytics.logEvent({
      name: event ? event : "select_content",
      params: {
        content_type: category ? category : "button",
        content_id: label,
      },
    });
  }
}

/**
 * Installation procedure
 *
 * @param Vue
 * @param initConf
 */
const install = (Vue, initConf: { vueRouter, ignoredViews, trackOnNextTick}) => {

  // Handle vue-router if defined
  if (initConf.vueRouter) {
    initVueRouterGuard(Vue, initConf);
  }

  // Add to vue prototype and also from globals
  Vue.prototype.$gtm = Vue.gtm = new FirebaseAnalyticsPlugin();
};

/**
 * Init the router guard.
 *
 * @param Vue - The Vue instance
 * @param vueRouter - The Vue router instance to attach guard
 * @param {string[]} ignoredViews - An array of route name to ignore
 * @param trackOnNextTick - Whether or not call trackView in Vue.nextTick
 *
 * @returns {string[]} The ignored routes names formalized.
 */
const initVueRouterGuard = (Vue, { vueRouter, ignoredViews, trackOnNextTick }) => {
  // Flatten routes name
  if (ignoredViews) {
    ignoredViews = ignoredViews.map(view => view.toLowerCase());
  }

  vueRouter.afterEach(to => {
    // Ignore some routes
    if (!to.name || (ignoredViews && ignoredViews.indexOf(to.name.toLowerCase()) !== -1)) {
      return;
    }

    // Dispatch vue event using meta gtm value if defined otherwise fallback to route name
    const name = to.meta.gtm || to.name;
    const baseUrl = vueRouter.options.base || "";
    let fullUrl = baseUrl;
    if (!fullUrl.endsWith("/")) {
      fullUrl += "/";
    }
    fullUrl += (to.fullPath.startsWith("/") ? to.fullPath.substr(1) : to.fullPath);

    if (trackOnNextTick) {
      Vue.nextTick(() => {
        Vue.gtm.trackView(name, fullUrl);
      });
    } else {
      Vue.gtm.trackView(name, fullUrl);
    }
  });

  return ignoredViews;
};

const setUser = (Vue, userId) => {
  Vue.gtm.setUser(userId);
};


export default { install, setUser};